/* VizMarkerDefs — the shared SVG <defs> arrowheads of the flow graphs:
 * default + highlighted (both visuals), compensation (dashed red) and
 * loop-repeat (dashed violet) for the workflow pipeline. */
import React from 'react';

export default function VizMarkerDefs() {
    return (
        <defs>
            <marker id="apsVizArr" viewBox="0 0 10 10" refX="9" refY="5"
                markerWidth="7" markerHeight="7" orient="auto-start-reverse">
                <path d="M0,0 L10,5 L0,10 z" fill="var(--aps-border-strong)" />
            </marker>
            <marker id="apsVizArrHl" viewBox="0 0 10 10" refX="9" refY="5"
                markerWidth="7" markerHeight="7" orient="auto-start-reverse">
                <path d="M0,0 L10,5 L0,10 z" fill="var(--aps-primary)" />
            </marker>
            <marker id="apsWfgArrComp" viewBox="0 0 10 10" refX="9" refY="5"
                markerWidth="7" markerHeight="7" orient="auto-start-reverse">
                <path d="M0,0 L10,5 L0,10 z" fill="var(--aps-danger)" />
            </marker>
            <marker id="apsWfgArrLoop" viewBox="0 0 10 10" refX="9" refY="5"
                markerWidth="7" markerHeight="7" orient="auto-start-reverse">
                <path d="M0,0 L10,5 L0,10 z" fill="var(--aps-violet)" />
            </marker>
        </defs>
    );
}
